// @ts-nocheck
import moment from 'moment';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { getFormattedCountries } from '@/ts-helpers/campaign.helpers';
import DownloadSubHeaderBase from './DownloadSubHeaderBase';

function DownloadSubHeaderSingle() {
  const { formatMessage } = useIntl();

  const campaigns = useSelector(getSelectedCampaigns);

  const title = campaigns[0].name;
  const begin = moment(campaigns[0].beginDate).format('DD-MM-YYYY');
  const end = moment(campaigns[0].endDate).format('DD-MM-YYYY');

  return (
    <DownloadSubHeaderBase
      fields={[
        {
          name: formatMessage({
            defaultMessage: 'Campaign date:',
            id: 'reporting.header.multi.details.date'
          }),
          value: `${begin} - ${end}`
        },
        {
          name: formatMessage({
            defaultMessage: 'Country:',
            id: 'reporting.header.multi.details.country'
          }),
          value: getFormattedCountries(campaigns).join(', ')
        }
      ]}
      title={title}
    />
  );
}

export default DownloadSubHeaderSingle;
